import type { JSX } from 'react';

import { withPrefetchedData } from 'src/shared/prefetch';

import { BannerSwitchContainer } from './BannerSwitch';
import { MaintenanceBannerContainer } from './MaintenanceBanner';

export const BannerContainer = withPrefetchedData(
	function BannerContainer(): JSX.Element {
		return (
			<>
				<MaintenanceBannerContainer />
				<BannerSwitchContainer />
			</>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchDependencies: [MaintenanceBannerContainer, BannerSwitchContainer],
	},
);
